module.exports = __webpack_public_path__ + "/9efb86976bd53e159166c12365f61e25.woff2";